export const onDialogAddDoneProp = property => ({
  widget: 'models',
  type: 'onDialogAddDoneProp',
  payload: { property },
})



// WEBPACK FOOTER //
// ./src/models/actions/onDialogAddDoneProp.js